import "../../css/pages/form.scss";
import customForm from "../modules/customForm";
import BasePage from "./base";

class FormPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
        customForm.init();
    }
}

new FormPage();
